<template>
    <AdmPanel>
        <h2 slot="header_title">{{ !isAudit ? "负面行为" : "负面行为数据" }}</h2>
        <div class="adm-buttons" slot="header_buttons">
          <!-- 导出 -->
          <iv-button
            :loading="loader[NEGATIVE_SENTIMENT+'exportNegativeSentiment']"
            v-rbac-allow="['publicSentiment','export']"
            type="info"
            icon="md-download"
            ghost
            class="export-excel-btn"
            @click="exportExcel()"
          >导出</iv-button>

          <!-- 新建 -->
           <iv-button
            v-rbac-allow="['publicSentiment','export']"
            type="primary"
            class="add-btn"
            icon="md-add"
            @click="onModalChange('create', null)"
          >新建</iv-button>
        </div>
        <div class="filter-wrapper">
          <FilterBar slot="tools" :value="conditions" :condition="options.filter_rules" @search="changeQuery">
            <iv-button
                :disabled="loader[NEGATIVE_SENTIMENT]"
                type="info"
                @click="changeQuery()"
            >
                <iv-icon type="md-search" size="14" style="vertical-align:text-bottom"/>查询
            </iv-button>
          </FilterBar>
        </div>
        <div>
          <p v-if="list.data.length <= 0 " class="text-center">
            <EmptyData>
              <div class="nextPage" slot="emptyBtn">
                <iv-button @click="refresh()">重新获取</iv-button>
              </div>
            </EmptyData>
          </p>
          <template v-else-if="isAudit">
            <iv-card class="adm-checklist" dis-hover :bordered="false">
              <iv-checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll"> 全选</iv-checkbox>
              <span>已选 {{ selection.list.length }} 项目，所选项将</span>
              <span class="adm-buttons">
                <iv-button type="primary" :disabled="selection.list.length<=0" size="small" @click="reviewList('pass')">通过</iv-button>
                <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0" :disabled="selection.list.length<=0">不通过</iv-button>
                <iv-poptip ref="selectionPoptipTop" v-model="selection.shown" v-else>
                  <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
                  <div slot="content" style="text-align: left;">
                    <iv-form label-position="top">
                      <iv-form-item label="审核批注（选填）">
                        <iv-input type="textarea" v-model="selection.comment" />
                      </iv-form-item>
                      <div class="adm-buttons" style="text-align:right">
                        <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipTop')">
                          取消
                        </iv-button>
                        <iv-button type="primary" size="small" @click="reviewList('fail');closeSelectionPoptip('selectionPoptipTop')">
                          发送
                        </iv-button>
                      </div>
                    </iv-form>
                  </div>
                </iv-poptip>
              </span>
            </iv-card>
            <iv-checkbox-group class="adm-list ui-wrapper" v-model="selection.list"
              @on-change="checkAllGroupChange">
              <BehaviorItem :value="item" type="audit" v-for="item in list.data" :key="item.id"
                :showLogButton="isAudit && $rbac.allow('operationLog')">
                <iv-checkbox slot="checkbox" :label="item.id"><span></span></iv-checkbox>
                <iv-button slot="buttons" v-rbac-allow="['negativeSentiment', 'audit']" type="primary" size="small" @click="review('pass',item)">通过</iv-button>
                <iv-poptip slot="buttons" v-rbac-allow="['negativeSentiment', 'audit']" :ref="'selectionPoptipDown' + item.id" v-model='item.shown'>
                  <iv-button type="primary" ghost size="small">不通过</iv-button>
                  <div slot="content" style="text-align: left;">
                    <iv-form label-position="top">
                      <iv-form-item label="审核批注（选填）">
                        <iv-input type="textarea" v-model="item.comment" />
                      </iv-form-item>
                      <div class="adm-buttons" style="text-align:right">
                        <iv-button type="text" size="small"
                          @click="closeSelectionPoptip('selectionPoptipDown' + item.id )">
                          取消
                        </iv-button>
                        <iv-button type="primary" size="small"
                          @click="review('fail',item);closeSelectionPoptip('selectionPoptipDown' + item.id)">
                          发送
                        </iv-button>
                      </div>
                    </iv-form>
                  </div>
                </iv-poptip>
              </BehaviorItem>
            </iv-checkbox-group>
            <iv-card class="adm-checklist" dis-hover :bordered="false">
              <iv-checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll"> 全选</iv-checkbox>
              <span>已选 {{ selection.list.length }} 项目，所选项将</span>
              <span class="adm-buttons">
                <iv-button type="primary" :disabled="selection.list.length<=0" size="small" @click="reviewList('pass')">通过</iv-button>
                <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0" :disabled="selection.list.length<=0">不通过</iv-button>
                <iv-poptip ref="selectionPoptipDown" v-model="selection.shonw2" v-else>
                  <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
                  <div slot="content" style="text-align: left;">
                    <iv-form label-position="top">
                      <iv-form-item label="审核批注（选填）">
                        <iv-input type="textarea" v-model="selection.comment" />
                      </iv-form-item>
                      <div class="adm-buttons" style="text-align:right">
                        <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipDown')">
                          取消
                        </iv-button>
                        <iv-button type="primary" size="small" @click="reviewList('fail');closeSelectionPoptip('selectionPoptipDown')">
                          发送
                        </iv-button>
                      </div>
                    </iv-form>
                  </div>
                </iv-poptip>
              </span>
            </iv-card>
          </template>
          <div class="adm-list ui-wrapper" v-else>
            <BehaviorItem v-for="item in list.data" :key="item.id" :value="item" type="audit" :showLogButton="$rbac.allow('operationLog')">
              <iv-button slot="buttons" size='small' type="primary"
                v-rbac-allow="['negativeSentiment', 'edit']"
                @click="onModalChange('edit',item)">修改</iv-button>
              <iv-poptip slot="buttons"
                v-rbac-allow="['negativeSentiment', 'delete']" confirm :title="`您确认删除这条内容？`" @on-ok="deleteItem(item)">
                <iv-button size='small' type="primary" ghost>删除</iv-button>
              </iv-poptip>
            </BehaviorItem>
          </div>
          <template v-if="list.last_page > 1">
            <div slot="footer" class="pull-right" style="margin-top: 1em">
              <iv-page @on-change="pageChanged" :current="list.current_page" :page-size="10" show-elevator show-total
                :total="list.total">
              </iv-page>
            </div>
          </template>
        </div>
        <router-view />
        <NegativeSentimentDataModal
          :mask-closable="false"
          :shown="status.NegativeSentimentData.shown"
          :value="status.NegativeSentimentData.value"
          :type="status.NegativeSentimentData.type"
          :title="status.NegativeSentimentData.title"
          :width="status.NegativeSentimentData.width"
          :options="options"
          @refresh="refresh"
          @refreshCompanys="refreshCompanys"
          @shown-changed="status.NegativeSentimentData.shown=$event;refresh()"
        >
        </NegativeSentimentDataModal>
    </AdmPanel>
</template>
<script>
import Vue from 'vue';
import Fecha      from '@/utils/type/Fecha'
import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import contact from "@/utils/contact";
import { conditioner, defaultVal, unique, downloadByUrl, years, getProductYear } from '@/utils/';

import FilterBar from "@/components/FilterBar_X2";
import NegativeSentimentModel from '@/models/NegativeSentimentModel';
import IndustryModel from '@/models/IndustryModel'
import CompanyModel    from '@/models/CompanyModel'
import TargetModel    from '@/models/TargetModel'
import AuditModel    from '@/models/AuditModel'

import BehaviorItem from '@/components/BehaviorItem'
import EmptyData from '@/components/EmptyData'
import NegativeSentimentDataModal from '@/components/NegativeSentimentDataModal'


const getTimeScope = (now=new Date)=>{
  const month = now.getMonth()
  const ranges = [
    [[1,6], now=>[new Date(now.getFullYear()-1, 0, 1),now]],
    [[7,8], now=>[new Date(now.getFullYear()-1, 0, 1), new Date(now.getFullYear(), 5, 30)]],
    [[9,12], now=>[new Date(now.getFullYear(), 0, 1), now]]
  ]

  return ranges.filter(([[start, end]])=>start>=month&&month<=end).reduce((_r,[_,time])=>time(now), "")
}

const _years = years().map(year=>({...year, title:year.name}))

const options = {
  sentiment_list:[
    { id:'负面' , title:'负面' },
    { id:'正面' , title:'正面' }
  ],
  audit: [
    // { id: '0', name: '全部审核状态' },
    { id: '1', name: '待审核' },
    { id: '2', name: '不通过' },
    { id: '3', name: '通过' },
  ]
}
const _conditioner = conditioner(
      { // ui to url
        limit           : {type: Number, default: 10},
        industryId      : {type: Number, default: ""},
        stockCode       : {type: String, default: ""},
        firstTargetNum  : {type: String, default: ""},
        secondTargetNum : {type: String, default: ""},
        audit           : { type: Number, default: "" },
        year            : { type: Number , default: "" },
      },
      { // url to ui
        limit           : {type: Number, default: 10},
        industryId      : {type: Number, default: ""},
        stockCode       : {type: String, default: ""},
        firstTargetNum  : {type: String, default: ""},
        secondTargetNum : {type: String, default: ""},
        audit           : {type: String, default: "" },
        year            : {type: Number , default: ()=>getProductYear()},
      }
  )

const filter_rules = [
    {name: 'year', type: "Select", options: _years, title: '年份', default: "", placeholder: "年份"},
    {name: 'industryId', type: "Select", options: [], title: '行业', default: "", placeholder: "行业", filterable:true, clearable:true, style: { width: "150px" }},
    {name: 'stockCode', type: "Select", options: [], title: '公司', default: "", placeholder: "公司", filterable:true, clearable:true, style: { width: "150px" }},
    {name: 'firstTargetNum', type: "Select", options: [], title: '一级指标', default: "", placeholder: "一级指标", filterable:true,
    clearable:true, style: { width: "150px" }},
    {name: 'secondTargetNum', type: "Select", options: [], title: '二级指标', default: "", placeholder: "二级指标", filterable:true,
    clearable:true, style: { width: "150px" }},
    {name: 'title',type: "Input", title: '标题', default: "", placeholder: "", style: { width: "200px" }},
    {name: 'audit', type: "Select", options: options.audit, title: '审核状态', default: '', placeholder: "审核状态",
    clearable:true, style: { width: "150px" }},
    {name: 'id',type: "Input", title: '编号', default: "", placeholder: "", style: { width: "200px" }},
]

const COMPANY = CompanyModel.ModelName;
const ModelName = NegativeSentimentModel.ModelName;
const NEGATIVE_SENTIMENT = NegativeSentimentModel.ModelName
const TARGET = TargetModel.ModelName
const ADUIT = AuditModel.ModelName
const INDUSTRY = IndustryModel.ModelName

export default {
        name: "negative_sentiment",
        mixins:[
            LoaderMixin(
              COMPANY,
              NEGATIVE_SENTIMENT,
              TARGET,
              ADUIT,
              NEGATIVE_SENTIMENT+'exportNegativeSentiment',
              INDUSTRY
            ),
            StatusMixin('negative_sentiment')(['loading']),
            StatusMixin('NegativeSentimentData')([
              { name: "title", default: "新建舆情榜单" },
              { name: "type", default: "create" },
              { name: "shown", default: false },
              { name: "width", default: "800" },
              { name: "value", default: null },
            ]),
            ModelMixin({
                contact,
                models:[
                    CompanyModel,
                    NegativeSentimentModel,
                    TargetModel,
                    AuditModel,
                    IndustryModel
                ]
            })
        ],
        data() {
            return {
                editModal: false,
                conditions: _conditioner.default(),
                NEGATIVE_SENTIMENT,
                TARGET,
                ADUIT,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    industry:[],
                    companys: [],
                    filter_rules,
                    firstTargetList:[],
                    secondTargetList:[],
                },

                firstTarget:'',
                secondTarget:'',
                formValidate: {},
                fixCurrentItem: null,
                indeterminate: false,
                checkAll: false,
                selection: {
                  list: [],
                  comment: "",
                  shown: false,
                },
            }
        },
        async mounted () {
            const { query, params } = this.$route
            let conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式
            this.options.year = years().map(year=>({...year,title:year.name}))
            this.conditions = conditions

            console.log("mounted",JSON.stringify(conditions))

            const industries = await this.refreshIndustry(conditions.year)
            this.renderFilterBar("industryId", industries)

            // conditions.industryId = defaultVal(conditions.industryId, industries[0].id)

            const companys = await this.refreshCompanys(conditions.industryId)
            this.renderFilterBar("stockCode", companys)

            const firstTarget = await this.refreshFirstTarget()
            this.renderFilterBar("firstTargetNum", firstTarget)

            const secondTarget = await this.refreshSecondTarget({ industryId:conditions.industryId, firstTargetNum:
            conditions.firstTargetNum, year: conditions.year })
            this.renderFilterBar("secondTargetNum", secondTarget)



            this.$nextTick(async ()=>{
                await this.refresh()
            })
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
              const { query, params } = to
              let conditions = {
                ..._conditioner.default(),
                ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
              }

              console.log("beforeRouteUpdate",JSON.stringify(conditions))

              // conditions.industryId = defaultVal(conditions.industryId, this.options.industry[0].id)

              let secondTarget = await this.refreshSecondTarget({ industryId:conditions.industryId , firstTargetNum:
              conditions.firstTargetNum, year: conditions.year })
              this.renderFilterBar("secondTargetNum", secondTarget)
              this.conditions = conditions

              await this.refresh()
            })
            next();
        },
        methods: {
            async refresh(query=this.conditions){
                const conditions = {...query}
                this.list = await this.$$fetch(NEGATIVE_SENTIMENT, conditions);
                this.list.current_page = conditions.offset ? conditions.offset / conditions.limit + 1 : 1
                this.list.last_page = this.list.total / conditions.limit
                this.selection.checkboxData = []
                this.selection.list = []
                this.indeterminate = false
            },
            async refreshFirstTarget(query){
                const result = await this.$$active(TARGET, 'firstTarget', _conditioner.parse({...query,limit:9999}))
                return this.options.firstTargetList = result.data.map(item=>({id:item.firstTargetNum,name:item.firstTargetName}))
            },
            async refreshSecondTarget(query){
                var result = await this.$$active(TARGET, 'sentiment', _conditioner.parse({...query,limit:9999}))
                return this.options.secondTargetList = result.data.map(item=>({id:item.secondTargetNum,name:item.secondTargetName}))
            },
            async refreshIndustry(year){
                const industry = await this.$$fetch(INDUSTRY,{ year: year })
                if(industry)  this.options.industry = industry.data.map(item=>({...item,name:item.industry}))
                return this.options.industry
            },
            async refreshCompanys(industryId){
                const res = await this.$$fetch(COMPANY, {industryId, limit: 9999})
                return this.options.companys = res.data.map(item=>({ id: item.stockCode, name: item.stockCode+' '+item.abbreviation }))
            },
            renderFilterBar(fieldName, val, defaults){
                const fieldset = this.options.filter_rules.find(fieldset=>fieldset.name===fieldName)
                fieldset.options = val
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            mergeQuery(query){
              return { ...this.conditions, ...query}
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.$router.push({
                    name  : this.$route.name,
                    query: {..._conditioner.parse(query), offset:0},
                    params: params
                });
            },
            async exportExcel(query = this.conditions) {
              // TODO:
              console.log("exportExcel...", this.conditions)
              const res = await this.$$active(NEGATIVE_SENTIMENT, 'exportNegativeSentiment', {..._conditioner.parse(query),
              type:'negativeSentiment'})
              if(!res.data.url) {
                this.$$info('后台未返回url，请重试')
                return
              }
              // 下载链接
              downloadByUrl(res.data.url)
            },
            serializeQuery(ids, sources, fieldName='id'){
              return sources.filter(item=>ids.indexOf(item[fieldName])>-1)
            },
            removeConditioner(fieldName, removeItem, keyField="id"){
              const list = [...this.conditions[fieldName]]
              const index = list.findIndex(item=>item[keyField]==removeItem[keyField])
              list.splice(index,1)
              this.changeQuery(this.mergeQuery({ [fieldName]: list, offset:0 }))
            },
            async review(action_name, item){
                const { id,comment } = item
                const target = { id, audit:0, comment }
                switch(action_name){
                    case 'pass':
                        target.audit = 3
                        break;
                    case 'fail':
                        target.audit = 2
                        break;
                }
                try{
                    this.$$loading(ADUIT);
                    await this.$$active(ADUIT, 'negativeSentiment', target)
                    this.$$loaded(ADUIT);
                }catch(e){
                    this.$$error(e)
                }
                this.refresh()
            },
            async reviewList(action_name, comment=this.selection.comment ,idList=this.selection.list){
              const audit = ['','','fail','pass'].indexOf(action_name)
              try {
                this.$$loading(ADUIT);
                await this.$$active(ADUIT, "batchNegativeSentiment", { comment, audit, idList});
                this.$$loaded(ADUIT);
              } catch (e) {
                this.$$error(e);
              }
              this.refresh();
              this.$nextTick(()=>{
                this.selection.comment = ""
                this.selection.list = []
              })
            },
            closeSelectionPoptip(ref){
              this.$refs[ref].visible = false
            },
            checkboxData(){
                this.selection.list = []
                this.selection.checkboxData.map(item=> this.selection.list.push((this.list.data.filter(i=>i.id==item))[0]))
                this.checkAllGroupChange(this.selection.list)
            },
            checkAllGroupChange (data) {
                if (data.length === this.list.data.length) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;
                this.selection.list = this.checkAll ? this.list.data.map(i=>i.id) : []
            },
            deleteItem(item){
              this.$$active(ModelName, "deleteNegativeSentiment",item)
              this.refresh()
            },
            onModalChange(type='create',item){
              switch(type){
                case 'create':
                  this.status.NegativeSentimentData.title ='新建负面行为'
                  this.status.NegativeSentimentData.value = null
                  this.status.NegativeSentimentData.type = 'create'
                  break;
                case 'edit':
                  this.status.NegativeSentimentData.title = '编辑负面行为'
                  this.status.NegativeSentimentData.value = item
                  this.status.NegativeSentimentData.type = 'edit'
                  break;
              }
              this.status.NegativeSentimentData.shown = true
            }
        },
        computed: {
          isAudit(){
            return this.$route.matched.some(item=>item.name=='audit')
          }
        },
        watch:{
            async ['conditions.industryId'](newVal, oldVal){
                if(newVal != oldVal){
                    let companys = await this.refreshCompanys(newVal)
                    this.renderFilterBar("stockCode", companys)

                    let secondTarget = await this.refreshSecondTarget({ industryId: newVal ,
                    firstTargetNum: this.conditions.firstTargetNum ,year:this.conditions.year})
                    this.renderFilterBar("secondTargetNum", secondTarget)
                }
            },
            async ['conditions.year'](newVal, oldVal){
              console.log(newVal, oldVal)
              if(newVal != oldVal){
                const industries = await this.refreshIndustry(newVal)
                this.renderFilterBar("industryId", industries)

                let secondTarget = await this.refreshSecondTarget({ industryId: this.conditions.industryId,
                firstTargetNum: this.conditions.firstTargetNum ,year:newVal})
                this.renderFilterBar("secondTargetNum", secondTarget)
              }
            },
            async ['conditions.firstTargetNum'](newVal, oldVal){
              if(newVal != oldVal){
                let secondTarget = await this.refreshSecondTarget({ industryId: this.conditions.industryId,
                firstTargetNum: newVal ,year:this.conditions.year})
                this.renderFilterBar("secondTargetNum", secondTarget)
              }
            },
        },
        components:{
            FilterBar,
            EmptyData,
            BehaviorItem,
            NegativeSentimentDataModal
        }
    }
</script>
<style lang="scss" scoped>
.filter-wrapper {
  position: relative;
  .export-excel-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
  .add-btn{
    position: absolute;
    right: 70px;
    top: 0;
  }
}
</style>
